import React from "react";
import { routePoints } from "../utils/activities";
export const PALETTES = {
  trail: {
    name: "Trail",
    background: "#fbf4e4",
    ink: "#2f6655",
    accent: "#c35538",
  },
  ink: {
    name: "Ink",
    background: "#fbf4e4",
    ink: "#29271f",
    accent: "#29271f",
  },
  sunset: {
    name: "Sunset",
    background: "#f5dcc6",
    ink: "#943d2b",
    accent: "#d97636",
  },
};
export default function ArtPoster({
  activities,
  layout = "grid",
  palette = "trail",
  year,
  posterRef,
}) {
  const p = PALETTES[palette],
    count = activities.length,
    columns = Math.ceil(Math.sqrt(count || 1)),
    rows = Math.ceil(count / columns),
    size = Math.min(600 / columns, 560 / (rows || 1));
  return (
    <svg
      ref={posterRef}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 720 900"
      role="img"
      aria-label={`${year} route poster with ${count} selected activities in ${layout} style`}
    >
      <rect width="720" height="900" fill={p.background} />
      <rect
        x="24"
        y="24"
        width="672"
        height="852"
        fill="none"
        stroke={p.ink}
        strokeWidth="1"
      />
      <text
        x="60"
        y="85"
        fill={p.ink}
        fontFamily="monospace"
        fontSize="13"
        letterSpacing="2"
      >
        STRAVA WRAPPED / ROUTE COLLECTION
      </text>
      <text
        x="60"
        y="145"
        fill={p.ink}
        fontFamily="Georgia,serif"
        fontSize="47"
        fontWeight="bold"
      >
        A year in motion.
      </text>
      <text
        x="658"
        y="146"
        textAnchor="end"
        fill={p.accent}
        fontFamily="monospace"
        fontSize="29"
      >
        {year}
      </text>
      <line x1="60" y1="175" x2="660" y2="175" stroke={p.ink} />
      {activities.map((a, i) =>
        layout === "grid" ? (
          <g
            key={a.id}
            transform={`translate(${60 + (600 - columns * size) / 2 + (i % columns) * size},${210 + (560 - rows * size) / 2 + Math.floor(i / columns) * size}) scale(${size / 200})`}
          >
            <polyline
              points={routePoints(a)}
              fill="none"
              stroke={i % 3 === 0 ? p.accent : p.ink}
              strokeWidth={Math.min(5, (1.8 * 200) / size)}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        ) : (
          <g key={a.id} transform="translate(90,225) scale(2.7)">
            <polyline
              points={routePoints(a)}
              fill="none"
              stroke={i % 3 === 0 ? p.accent : p.ink}
              strokeWidth="0.7"
              opacity="0.65"
              strokeLinecap="round"
            />
          </g>
        ),
      )}
      {count === 0 && (
        <text
          x="360"
          y="480"
          textAnchor="middle"
          fill={p.ink}
          fontFamily="monospace"
          fontSize="19"
        >
          SELECT ROUTES TO BEGIN
        </text>
      )}
      <line x1="60" y1="801" x2="660" y2="801" stroke={p.ink} />
      <text x="60" y="836" fill={p.ink} fontFamily="monospace" fontSize="13">
        {count} ROUTES. A WHOLE LOT OF MEMORIES.
      </text>
      <text x="60" y="858" fill={p.ink} fontFamily="monospace" fontSize="11">
        POWERED BY STRAVA
      </text>
      <text
        x="660"
        y="840"
        textAnchor="end"
        fill={p.accent}
        fontFamily="monospace"
        fontSize="24"
      >
        ↗
      </text>
    </svg>
  );
}
